import moment from 'moment';
export const createContentPedidos = (items) => {
  const content = createDetailPedidos(items);
  return `${content}`;
};
function transformDate(date) {
  if (date && date.trim() !== '' && moment(date).isValid) {
    return date;
  }
  return '';
}
export const downloadFileByPedidos = (fileData, fileType) => {
  const content = createContentPedidos(fileData);
  let name = `BackOrder${fileType}.txt`;
  if (content !== null) {
    const element = document.createElement('a');
    const file = new Blob([content], {'type': 'text/csv'});
    element.href = URL.createObjectURL(file);
    element.download = name;
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  } else {
    this.props.addMessageBoxError(
      'Error, faltan datos para generar el documento'
    );
  }
};
    
/* eslint-disable camelcase, max-statements, max-len*/
function createDetailPedidos(items) {
  let result = '';
  if (items.length > 0) {
    items.forEach(
      ({
        orderType,
        user,
        partCode,
        agency,
        orderDate,
        invoiceDate,
        status,
        orderNumber,
        orderQuantity,
      }) => {
        const orderType2 = String(orderType).padEnd(2, ' ');
        const user2 = String(user).padEnd(31, ' ');
        const partCode2 = String(partCode).padEnd(21, ' ');
        const agency2 = String(agency).padEnd(5, ' ');
        const orderDate2 = String(orderDate).padEnd(11, ' ');
        const invoiceDate2 = String(transformDate(invoiceDate)).padEnd(11, ' ');
        const status2 = String(status).padEnd(5, ' ');
        const orderNumber2 = String(orderNumber).padEnd(13, ' ');
        const orderQuantity2 = String(orderQuantity).padEnd(7, ' ');
  
        let line = `${orderType2}${user2}${partCode2}${agency2}`;
        line = `${line}${orderDate2}${invoiceDate2}${status2}${orderNumber2}${orderQuantity2}`;
        line = `${line}\n`;
        result = result + line;
      }
    );
  }
  return result;
}
